import React from 'react';
import Configuraciones from '../../components/configuraciones/Configuraciones';
import Layout from '../../components/layout/Layout';

const ConfiguracionesPage = () => {
    return ( <Layout children={<Configuraciones />} /> )
}

export default ConfiguracionesPage